import { mapGetters, mapMutations } from 'vuex';
import Forms from './../../utils/forms/forms';
import paymentMethodService from './../../services/paymentMethods';
import billService from './../../services/bill';

export default {
  data() {
    return {
      form: new Forms({
        isFullyPaid: {
          value: false,
          type: 'checkbox',
        },
        amountPaid: {
          value: '',
          type: 'float',
        },
        paymentMethod: {
          value: '',
          type: 'select',
        },
        paymentDate: {
          value: new Date(),
          type: 'date',
        },
        reference: {
          value: '',
          type: 'text',
        },
        internalNote: {
          value: '',
          type: 'textarea',
        },
      }),
      loading: false,
    };
  },

  computed: {
    ...mapGetters({
      paymentMethods: 'paymentMethods',
    }),

    listPaymentMethods() {
      return this.paymentMethods.map(item => ({
        id: item.id,
        name: this.$t(`static.reports.bills.${item.name.replace(/\s+/g, '').toLowerCase()}`),
      }));
    },
  },

  watch: {
    'form.isFullyPaid': function (value) {
      if (value === true) {
        this.form.setFieldValue('amountPaid', this.additionalData.due);
        this.form.disableField('amountPaid');
      } else {
        this.form.enableField('amountPaid');
      }
    },
  },

  mounted() {
    this.loading = true;
    this.form.setFieldValue('amountPaid', this.additionalData.due);
    Promise.all([
      paymentMethodService.all(),
    ]).then(() => {
      this.form.setOptions('paymentMethod', this.listPaymentMethods);
      const defaultMethod = this.listPaymentMethods.filter(obj => obj.name === this.$t('static.reports.bills.banktransfer'));
      this.form.paymentMethod = defaultMethod[0].id;
      this.loading = true;
    }).catch((error) => {
      this.loading = true;
    });
  },

  methods: {
    ...mapMutations({
      toggle: 'TOGGLE_MODAL',
      unsetModalContent: 'UNSET_MODAL_CONTENT',
    }),

    complete() {
      this.form.loading = true;
      billService.payment(this.billId, this.form.data())
       .then(() => {
         this.form.loading = false;
         this.onSave('Cleared', this.form.data());
         this.closeModal();
       })
      .catch((errors) => {
        this.form.loading = false;
        this.form.recordErrors(errors);
      });
    },

    /*
     * Closes the modal
     */
    closeModal() {
      this.toggle(false);
      this.unsetModalContent();
      this.onClose();
    },
  },

  props: {
    billId: {
      type: Number,
      required: true,
    },
    onSave: {
      type: Function,
      required: true,
      default: () => {},
    },
    onClose: {
      type: Function,
      required: false,
      default: () => {},
    },
    billingNumber: {
      type: String,
      required: true,
    },
    additionalData: {
      type: Object,
      required: true,
    },
  },

  components: {
    VForm: require('./../../components/form/form.vue'),
    VMessage: require('./../../components/form/message/message.vue'),
  },
};



// WEBPACK FOOTER //
// ./src/app/components/billPayment/billPayment.js